/**
 * Pseudo Variants - Product Variations Handler
 * Creates real URLs for each product variant using tags (group_*)
 */

window.pseudoVariants = {
  init(options = {}) {
    this.options = options;
    this.setupAllContainers();
  },

  setupAllContainers() {
    document.querySelectorAll('.pseudo-variants--container')
      .forEach(container => this.setupContainer(container));
  },

  setupContainer(container) {
    const main = container.closest('.pseudo-variants--container-main');
    const scroller = container.querySelector('.scroller');
    const prevBtn = container.querySelector('.prev-btn');
    const nextBtn = container.querySelector('.next-btn');
    const tag = container.dataset.groupTag;
    const currentId = container.dataset.currentProduct;
    const currentCollection = container.dataset.currentCollection;
    
    if (!tag) return;

    scroller.innerHTML = '';
    main.classList.remove('active');

    // Fetch products with the same group tag using search API
    const fetchUrl = `/search?q=tag:${tag}&type=product&view=fetchTaggedProducts`;
    
    fetch(fetchUrl)
      .then(r => {
        if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
        return r.json();
      })
      .then(data => {
        const seen = new Set([currentId]);
        const items = (data.products || []).filter(p => p.image && !seen.has(`${p.id}`));
        
        if (items.length === 0) return;
        
        main.classList.add('active');
        
        items.forEach(p => {
          seen.add(`${p.id}`);
          const link = document.createElement('a');
          
          // Build proper URL with collection context if available
          const coll = currentCollection &&
            p.collections.find(c => c.handle === currentCollection);
          link.href = coll
            ? `/collections/${coll.handle}/products/${p.handle}`
            : p.onlineStoreUrl;
          link.title = p.title;
          
          const img = document.createElement('img');
          img.loading = "lazy";
          img.src = p.image;
          img.alt = p.title;
          link.appendChild(img);
          scroller.appendChild(link);
        });
        
        this.updateButtons(container);
      })
      .catch(err => {
        console.error('Error loading pseudo variants:', err);
      });

    const calcScrollAmt = () => {
      const first = scroller.querySelector('a');
      return first
        ? first.offsetWidth * 1.5
        : (this.options.scrollAmount || 200);
    };

    const doScroll = dir => {
      const amt = calcScrollAmt() * (dir < 0 ? -1 : 1);
      scroller.scrollBy({ left: amt, behavior: 'smooth' });
      setTimeout(() => this.updateButtons(container), 300);
    };

    prevBtn.onclick = e => { e.preventDefault(); doScroll(-1); };
    nextBtn.onclick = e => { e.preventDefault(); doScroll(1); };
    scroller.onscroll = () => this.updateButtons(container);
    window.onresize = () => this.updateButtons(container);
  },

  updateButtons(container) {
    const s = container.querySelector('.scroller');
    const p = container.querySelector('.prev-btn');
    const n = container.querySelector('.next-btn');
    const { scrollLeft, scrollWidth, clientWidth } = s;
    const overflow = scrollWidth > clientWidth;
    
    p.style.display = n.style.display = overflow ? '' : 'none';
    if (!overflow) return;
    
    p.disabled = scrollLeft <= 0;
    n.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
  }
};

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.pseudoVariants.init();
  
  // Re-initialize on dynamic content loads (e.g., collection filters)
  document.addEventListener('collections-loaded', () =>
    setTimeout(() => window.pseudoVariants.init(), 150)
  );
});
